import animate from "./../global/animate.js";

// settings

let selectors = {
	menu: ".js-mobile-menu",
	menuOverlay: ".js-mobile-menu-overlay",
	buttonOpen: ".js-mobile-menu-open",
	buttonClose: ".js-mobile-menu-close",
	buttonToggle: ".js-mobile-menu-toggle"
};

let classNames = {
	block: "show!",
	open: "is-open",
	noScroll: "mobile-menu__no-scroll"
};

// elems

let $menu = $(selectors.menu);
let $menuOverlay = $(selectors.menuOverlay);
let $buttonOpen = $(selectors.buttonOpen);
let $buttonClose = $(selectors.buttonClose);
let $buttonToggle = $(selectors.buttonToggle);
let $html = $("html");

// state

let isOpen = false;

function init() {
	$buttonOpen.on("click", openMenu);
	$buttonClose.on("click", closeMenu);
	$buttonToggle.on("click", toggleMenu);
	$menuOverlay.on("click", closeMenu);

	// escape
	$(document).on("keydown", function(event) {
		if (event.which === 27 && isOpen === true) closeMenu();
	});
}

function openMenu(event) {
	isOpen = true;
	animate.show($menuOverlay, classNames.open);
	animate.show($menu, classNames.open);
	$menuOverlay.attr("aria-modal", true);
	$buttonToggle.addClass(classNames.open);
	$html.addClass(classNames.noScroll);
	return false;
}

function closeMenu(event) {
	isOpen = false;
	animate.hide($menuOverlay, classNames.open);
	animate.hide($menu, classNames.open);
	$menuOverlay.attr("aria-modal", false);
	$buttonToggle.removeClass(classNames.open);
	$html.removeClass(classNames.noScroll);
	return false;
}

function toggleMenu(event) {
	if (isOpen) {
		closeMenu();
	} else {
		openMenu();
	}
}

export default {
	init
};
